<template>
  <MyOrdersHighFrequencyCard v-bind="data">
    <template #header>
      <MyOrdersHighFrequencyStatus v-bind="{ count, status }" />
    </template>
  </MyOrdersHighFrequencyCard>
</template>

<script lang="ts" setup>
import {
  type HighFrequency_Order,
  HighFrequency_OrderStatus,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

import { HighFrequency_OrderStatusActive } from '../utils/types'

type MyOrdersHighFrequencyCardActiveProps = { data: HighFrequency_Order }

const { data } = defineProps<MyOrdersHighFrequencyCardActiveProps>()

const count = computed(() => data.readyDraws || undefined)

const status = computed(() => {
  const isPrinted = data.status === HighFrequency_OrderStatus.Printed
  const hasReadyDraws = data.readyDraws > 0
  const hasRevealedDraws = data.revealedDraws > 0
  const noReadyDraws = data.readyDraws === 0
  const notAllRevealed = data.revealedDraws < data.totalDraws

  if (isPrinted && hasReadyDraws) {
    return HighFrequency_OrderStatusActive.Ready
  }
  if (isPrinted && hasRevealedDraws && noReadyDraws && notAllRevealed) {
    return HighFrequency_OrderStatusActive.Pending
  }
  return data.status
})
</script>
